import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const DoubleChinLifestyle = lazyWithPreload(
  () => import('./DoubleChinLifestyle'),
)
